import { IRequestContext } from '@msdyn365-commerce/core';
import { useCallback, useEffect, useMemo } from 'react';
import { CookieService } from '../services/cookie-service/cookie-service';
import { UserCentricsService } from '../../integrations/userCentrics/UserCentricsService';

export const useConsentCookieSync = (request: IRequestContext) => {
    const cookieService = useMemo(() => new CookieService(request), [request]);

    const syncConsentCookies = useCallback(async () => {
        await cookieService.syncMsdynUserConsentCookie();
        await cookieService.syncConsentGatedCookies();
    }, [cookieService]);

    useEffect(() => {
        return UserCentricsService.subscribeToConsent(syncConsentCookies);
    }, [syncConsentCookies]);
};
